var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{staticClass:"sidebar global-nav"},[_c('f-menu',{attrs:{"nav-items":_vm.navItems,"is-child":false}})],1),_vm._v(" "),_c('div',{staticClass:"toggle-btn",class:{open: _vm.isOpen},on:{"click":_vm.toggle}})])}
var staticRenderFns = []

export { render, staticRenderFns }